<script setup lang="ts">
import Survey from '@/core/store/survey/surveyStore';
import { computed, ref } from 'vue';
import { SelectedItemType, PropertiesDisplayComponents, FieldTypeLabels, Form_type, DisplayType, FieldType } from '@/core/store/survey/surveyDesignDtos';
import bannerIcon from '/assets/bannerIcon.svg';
import SurveyPropertiesItems from './surveyPropertiesItems.vue';
import useUsers from '@/core/store/user/useUsers';
import { type _UnwrapAll } from 'pinia';
import FormulaCreatorDialog from './surveyFormulaCreatorDialog.vue';
import APISelectValuesDialog from './surveyAPIValuesSelectDialog.vue';
import surveyItemAPIselector from '../survey/itemsComponents/surveyItemAPIselector.vue';
import boxArrowDownLeftIcon from '@/assets/box-arrow-down-left.svg';
import formulaIcon from '@/assets/formula-icon.svg';



const { currentItem, selectedType, currentDesign, bindCab, displayMode, copyDesign, bindItem, showOriginSelector, showFormulaCreator } = Survey();
const { user } = useUsers();
const selectedDisplay = ref<boolean>(false)
const selectedInput = ref<boolean>(false)
const selectedPDF = ref<boolean>(false)
const selectZone = (type: DisplayType) => {
  displayMode.value = type;
  switch (type) {
    case DisplayType.EDIT:
      selectedInput.value = !selectedInput.value;
      selectedDisplay.value = false;
      selectedPDF.value = false;
      break;
    case DisplayType.DISPLAY:
      selectedDisplay.value = !selectedDisplay.value;
      selectedInput.value = false;
      selectedPDF.value = false;
      break;
    case DisplayType.PDF:
      selectedPDF.value = !selectedPDF.value;
      selectedInput.value = false;
      selectedDisplay.value = false;
      break;
  }
}
const hasLabel = computed(() => {
  if (!currentItem || !currentItem.value) return false;
  return PropertiesDisplayComponents[currentItem.value.type].labelStyle!!
})
const hasContent = computed(() => {
  if (!currentItem || !currentItem.value) return false;
  return PropertiesDisplayComponents[currentItem.value.type].contentStyle!!
})
const cab = computed(() => {
  return currentDesign.value.cab;
})
const copyInputToDisplay = (from: DisplayType, to: DisplayType) => {
  copyDesign(from, to);

}
const selectedForm = ref(false);
const setValueDisplay = (k: string, value, target) => {
  //bindItem("display", target, 'contentStyle', k, value);
  currentItem.value.properties[target][k] = value;
}
const selectOrigin = () => {
  showOriginSelector(currentItem.value);
}
const showOriginItem = computed<boolean>(() => {
  if (
    currentItem 
    && currentItem.value 
    && currentItem.value.type == FieldType.FORMREF
  ) return true;
  
  return false;
})


const showFormItem = computed<boolean>(() => {
  if (currentItem && currentItem.value && currentItem.value.type == FieldType.FORMULE) return true;
  return false;
})

const selectedApiId = ref('');
const formulaCreatorShow = ref(false);
const apiValuesShow = ref(false);

const showAPIItem = computed(() => {
  return currentItem.value && currentItem.value.type === FieldType.APIREST;
});


const openFormulaCreator = () => {
  formulaCreatorShow.value = true;
  showFormulaCreator(currentItem.value);
};


const closeFormulaCreator = () => {
  formulaCreatorShow.value = false;
};


const handleApiSelected = (api) => {
  selectedApiId.value = api.id;
};

const openAPIValues = () => {
  apiValuesShow.value = true;
};

const closeAPIValues = () => {
  apiValuesShow.value = false;
};

</script>

<template>
  <!-- #region para los items normales -->
  <div v-if="showOriginItem">
    <button class="btn-refForm" v-on:click="selectOrigin()">
      <img :src="boxArrowDownLeftIcon" width="20" height="20" alt="Seleccionar origen" />
      Seleccionar origen
    </button>
  </div>
  <div v-if="showFormItem && !currentItem.inheritItemId">
    <button class="btn-createFormula" @click="openFormulaCreator">
      <img :src="formulaIcon" width="25" height="25" alt="Crear fórmula" />
      Crear fórmula
    </button>
  </div>
  <div v-if="showAPIItem && !currentItem.inheritItemId">
    <surveyItemAPIselector @api-selected="handleApiSelected" /> <!-- Asegúrate de que el nombre del componente sea correcto -->
    <button class="btn-createFormula" @click="openAPIValues">
      <svg width="25" height="31" viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.34 18.2099C25.54 18.2099 28.14 15.61 28.14 12.41C28.14 9.20997 25.54 6.60992 22.34 6.60992C21.99 6.60992 21.64 6.6399 21.3 6.7099C20.84 3.0399 17.7 0.18988 13.9 0.18988C10.1 0.18988 7.11001 2.9099 6.54001 6.4599C3.17001 6.2599 0.320007 8.97989 0.320007 12.3299C0.320007 15.6799 2.96001 18.2099 6.20001 18.2099H7.48999V21.8499H5.42999C4.49999 21.8499 3.73999 22.61 3.73999 23.54V27.54C3.17999 27.87 2.79999 28.48 2.79999 29.18C2.79999 30.23 3.65999 31.0899 4.70999 31.0899C5.75999 31.0899 6.62 30.23 6.62 29.18C6.62 28.51 6.26999 27.9099 5.73999 27.5699V23.8499H7.79999C8.72999 23.8499 9.48999 23.09 9.48999 22.16V18.2099H13.17V31.4699C12.67 31.8099 12.34 32.39 12.34 33.04C12.34 34.09 13.2 34.9499 14.25 34.9499C15.3 34.9499 16.16 34.09 16.16 33.04C16.16 32.32 15.76 31.6999 15.17 31.3699V18.2099H18.85V22.27C18.85 23.2 19.61 23.9599 20.54 23.9599H22.6V27.5699C22.07 27.9099 21.72 28.5 21.72 29.18C21.72 30.23 22.58 31.0899 23.63 31.0899C24.68 31.0899 25.54 30.23 25.54 29.18C25.54 28.48 25.16 27.88 24.6 27.54V23.66C24.6 22.73 23.84 21.9699 22.91 21.9699H20.85V18.2199H22.33L22.34 18.2099ZM4.62 29.17C4.62 29.17 4.62001 29.1399 4.64001 29.1299C4.67001 29.1299 4.69999 29.15 4.73999 29.15C4.75999 29.15 4.77001 29.15 4.79001 29.15C4.79001 29.16 4.79999 29.17 4.79999 29.18C4.79999 29.28 4.62 29.28 4.62 29.18V29.17ZM2.32001 12.3199C2.32001 10.1799 4.06001 8.43988 6.20001 8.43988C6.52001 8.43988 6.85 8.47989 7.19 8.56989C7.49 8.64989 7.80999 8.58996 8.04999 8.39996C8.29999 8.20996 8.44 7.91992 8.44 7.60992C8.45 4.60992 10.9 2.17999 13.9 2.17999C16.9 2.17999 19.36 4.62995 19.36 7.63995C19.36 7.73995 19.36 7.82993 19.34 7.98993C19.31 8.33993 19.48 8.67994 19.77 8.87994C20.06 9.07994 20.44 9.10991 20.76 8.96991C21.27 8.73991 21.8 8.61993 22.35 8.61993C24.45 8.61993 26.15 10.33 26.15 12.42C26.15 14.51 24.44 16.2199 22.35 16.2199H6.20999C4.06999 16.2199 2.32999 14.4799 2.32999 12.3399L2.32001 12.3199Z" fill="currentColor"/></svg>
      Configuración de Valores
    </button>
    <APISelectValuesDialog :show="apiValuesShow"  @close="closeAPIValues" />
  </div>
  <FormulaCreatorDialog :show="formulaCreatorShow" @close="closeFormulaCreator" />
  <div
    v-if="[SelectedItemType.ITEM, SelectedItemType.PAGE, SelectedItemType.SECTION].includes(selectedType) && currentItem">
    <div class="topHeaderContainer">
      <span class="tittle-component">
        ({{ FieldTypeLabels[currentItem.type] }}) Propiedades
      </span>
    </div>
    <div v-on:click="selectZone(DisplayType.EDIT)" :class="{ 'is-flipped': selectedInput }">
      <div class="survey-banner">
        <h6 class="survey-bannerText">Visualización de entrada</h6>
        <img class="survey-bannerIcon" :src="bannerIcon" alt="Icono de survey-banner">
      </div>
    </div>
    <BCollapse v-model="selectedInput">

      <div class="survey-property-section">
        <div class="survey-property-section-Visible">
          <label class="checkboxLabel">Visible</label>
          <div class="survey-checkbox-container">
            <input type="checkbox" :checked="currentItem.properties.input.visible" v-on:change="($event: Event) => {
              setValueDisplay('visible', (($event.target) as HTMLInputElement).checked, 'input');
            }" class="customCheckbox1">
          </div>
        </div>
        <div class="surveyLabelItems" v-if="hasLabel">
          <SurveyPropertiesItems :target="DisplayType.EDIT" type="label" />
        </div>
        <div class="surveyContentItems" v-if="hasContent">
          <SurveyPropertiesItems :target="DisplayType.EDIT" type="content" />
        </div>
      </div>
    </BCollapse>
    <div v-on:click="selectZone(DisplayType.DISPLAY)" :class="{ 'is-flipped': selectedDisplay }">
      <div class="survey-banner">
        <h6 class="survey-bannerText">Visualización en pantalla</h6>
        <img class="survey-bannerIcon" :src="bannerIcon" alt="Icono de survey-banner">
      </div>
    </div>
    <BCollapse v-model="selectedDisplay">
      <button class="copyDesignBTN" v-on:click="copyInputToDisplay(DisplayType.EDIT, DisplayType.DISPLAY)"><i
          class="bi bi-copy"></i>Copiar diseño de entrada</button>
      <div class="survey-property-section">
        <div class="survey-property-section-Visible">
          <label class="checkboxLabel">Visible</label>
          <div class="survey-checkbox-container">
            <input type="checkbox" :checked="currentItem.properties.screen.visible" v-on:change="($event: Event) => {
              setValueDisplay('visible', (($event.target) as HTMLInputElement).checked, 'screen');
            }" class="customCheckbox1">
          </div>
        </div>
        <div class="surveyLabelItems" v-if="hasLabel">
          <SurveyPropertiesItems :target="DisplayType.DISPLAY" type="label" />
        </div>
        <div class="surveyContentItems" v-if="hasContent">
          <SurveyPropertiesItems :target="DisplayType.DISPLAY" type="content" />
        </div>
      </div>
    </BCollapse>
    <div v-on:click="selectZone(DisplayType.PDF)" :class="{ 'is-flipped': selectedPDF }">
      <div class="survey-banner">
        <h6 class="survey-bannerText">Formato PDF</h6>
        <img class="survey-bannerIcon" :src="bannerIcon" alt="Icono de survey-banner">
      </div>
    </div>
    <BCollapse v-model="selectedPDF">
      <button class="copyDesignBTN" v-on:click="copyInputToDisplay(DisplayType.DISPLAY, DisplayType.PDF)"><i
          class="bi bi-copy"></i>Copiar diseño de pantalla</button>
      <div class="survey-property-section">
        <div class="survey-property-section-Visible">
          <label class="checkboxLabel">Visible</label>
          <div class="survey-checkbox-container">
            <input type="checkbox" :checked="currentItem.properties.print.visible" v-on:change="($event: Event) => {
              setValueDisplay('visible', (($event.target) as HTMLInputElement).checked, 'print');
            }" class="customCheckbox1">
          </div>
        </div>
        <div class="surveyLabelItems" v-if="hasLabel">
          <SurveyPropertiesItems :target="DisplayType.PDF" type="label" />
        </div>
        <div class="surveyContentItems" v-if="hasContent">
          <SurveyPropertiesItems :target="DisplayType.PDF" type="content" />
        </div>
      </div>
    </BCollapse>

  </div>

  <div class="formPropertiesContainer" v-if="SelectedItemType.SURVEY == selectedType">
    <h6 class="tittle-component formTitle">
      (Formulario) Propiedades
    </h6>
    <div v-on:click="selectZone(DisplayType.EDIT)">

      <div class="survey-property-input-group2">
        <label class="survey-property-section-label">
          Nombre
        </label>
        <div class="survey-property-section-input">
          <input type="text" :value="cab.name" v-on:change="($event: Event) => {
              bindCab('name', (($event.target) as HTMLInputElement).value);
            }">
        </div>
      </div>
      <div class="survey-property-input-group2">
        <div class="survey-property-section-label">
          Usuario
        </div>
        <div class="survey-property-section-input">
          <input type="text" :value="cab.userEmail.trim().length ? cab.userEmail : user.email" :disabled="true" />
        </div>
      </div>
      <template v-if="cab.formType == Form_type.FROM">
        <div class="survey-property-input-group2" >
          <div class="survey-property-section-label">
            Inicio
          </div>
          <div class="survey-property-section-input">
            <input type="date" placeholder="dd/mm/yyyy" :value="cab.initDate" v-on:change="($event: Event) => {
                bindCab('initDate', (($event.target) as HTMLInputElement).value);
              }">
          </div>
        </div>
        <div class="survey-property-input-group2">
          <div class="survey-property-section-label">
            Fin
          </div>
          <div class="survey-property-section-input">
            <input type="date" placeholder="dd/mm/yyyy" :value="cab.endDate" v-on:change="($event: Event) => {
                bindCab('endDate', (($event.target) as HTMLInputElement).value);

              }">
          </div>
        </div>
      </template>
      <div class="survey-property-input-group2">
        <div class="survey-property-section-label">
          Componente
        </div>
        <div class="survey-property-section-input">
          <input type="checkbox" :checked="cab.formType == Form_type.COMPONENT" v-on:change="($event: Event) => {
            bindCab('formType', (($event.target) as HTMLInputElement).checked ? Form_type.COMPONENT : Form_type.FROM);
          }
            " class="custom-checkbox">
        </div>
      </div>
      <template v-if="cab.formType == Form_type.FROM">
        <div class="survey-property-input-group2">
          <div class="survey-property-section-label">
            Margen Sup.
          </div>
          <div class="survey-property-section-input">
            <input type="number" :value="cab.config.marginTop" v-on:change="($event: Event) => {
                bindCab('config', { ...cab.config, marginTop: (($event.target) as HTMLInputElement).value });

              }"><span>px</span>
          </div>
        </div>
        <div class="survey-property-input-group2">
          <div class="survey-property-section-label">
            Margen Inf.
          </div>
          <div class="survey-property-section-input">
            <input type="number" :value="cab.config.marginBottom" v-on:change="($event: Event) => {
                bindCab('config', { ...cab.config, marginBottom: (($event.target) as HTMLInputElement).value });
              }"><span>px</span>
          </div>
        </div>
        <div class="survey-property-input-group2">
          <div class="survey-property-section-label">
            Margen Izq.
          </div>
          <div class="survey-property-section-input">
            <input type="number" :value="cab.config.marginLeft" v-on:change="($event: Event) => {
                bindCab('config', { ...cab.config, marginLeft: (($event.target) as HTMLInputElement).value });
              }"><span>px</span>
          </div>
        </div>
        <div class="survey-property-input-group2">
          <div class="survey-property-section-label">
            Margen Der.
          </div>
          <div class="survey-property-section-input">
            <input type="number" :value="cab.config.marginRight" v-on:change="($event: Event) => {
                bindCab('config', { ...cab.config, marginRight: (($event.target) as HTMLInputElement).value });
              }"><span>px</span>
          </div>
        </div>

        <div class="survey-property-input-group2">
          <div class="survey-property-section-label">
            Núm. Pág.
          </div>
          <div class="survey-property-section-input">
            <input type="checkbox" :checked="cab.config.pageNumber" v-on:change="($event: Event) => {
              bindCab('config', { ...cab.config, pageNumber: (($event.target) as HTMLInputElement).checked });
            }" class="custom-checkbox">
          </div>
        </div>
    </template>
    </div>
  </div>
  <!-- #endregion-->
</template>


<style lang="scss">
@import url('./survey.scss');

.custom-checkbox {
  accent-color: var(--compositor-text);
  width: 20px;
  height: 20px;
  transform: translate(-82px, 2px);
}
</style>




<script lang="ts">
export default {
  name: 'SurveyProperties'
}
</script>
